<template>
  <div class='renewCaseList' id="renewCaseList">
    <div class="renew-case-box">
      <template v-for="(renewCase, index) in list">
        <div class="renew-case-item" :key="'renewCase' + index">
          <img class="renew-case-image" :src="renewCase.title_pic" alt="">
          <div class="right">
            <div class="renew-case-name">{{renewCase.case_name}}</div>
            <div class="renew-case-desc">{{renewCase.case_sub}}</div>
            <div class="infoBtn" @click="goInfo(renewCase)">查看详情</div>
          </div>
        </div>
      </template>
      <div v-if="isFinished" class="finished">没有更多</div>
      <div v-if="loading" class="finished">
        加载中
        <i class="el-icon-loading"></i>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const md5 = require('js-md5')
export default {
  name: 'renewCaseList',
  components:{ 
    
  },
  data() {
    return {
      list: [],
      search: {
        house_type: '',
        area_type: ''
      },
      loading: false,
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      isFinished: false,
    }
  },
  computed:{ },
  watch:{ },
  created() {
    this.getList()
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    getList() {
      if (this.isFinished || this.loading) return
      this.loading = true
      console.log(this.isFinished,  this.loading)
      const stamp = Date.now()
      // const user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
      const okey = atob(localStorage.getItem('okey'))
      const token = localStorage.getItem('token')
      const { pageNum, pageSize } = this.page
      axios.get('/interface/searchRenewCase', {
        params: {
          token,
          pageNum,
          pageSize,
          stamp,
          sign: md5(`${stamp}${pageNum}${pageSize}${okey}`)
        }
      }).then((res) => {
        console.log('indexCase', res)
        this.list = [...this.list, ...res.data.data]
        this.page.pageNum++
        if (res.data.data.length === 0 || !res.data.data) {
          this.isFinished = true
        }
        if (res.data.total <= this.list.length) {
          this.isFinished = true
        }
        this.loading = false
      })
    },
    onScroll() {
      const target = document.getElementById('renewCaseList');
      const targetRect = target.getBoundingClientRect();
      const distanceFromBottom = window.innerHeight - targetRect.bottom;
      if (distanceFromBottom > 0 && !this.isFinished) {
        console.log('onScroll')
        this.getList(); // 滚动到底部时加载数据
      }
    },
    goInfo(info) {
      console.log('goInfo', info)
      this.$emit('getInfo', info)
    }
  }
}
</script>
<style lang='less' scoped>
.renewCaseList {
  padding: 96px 237px;
  background: #fff;
  .renew-case-box {
    padding: 0 0 10px;
    display: flex;
    flex-direction: column;
    .renew-case-item {
      width: 1445px;
      height: 352px;
      background: #FFFFFF;
      box-shadow: 0px 0px 15px 0px rgba(153,153,153,0.47);
      border-radius: 15px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      padding: 18px;
      .renew-case-image {
        width: 736px;
        height: 313px;
        border-radius: 10px;
        object-fit: cover;
      }
      .right {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 10px 0 0 39px;
        position: relative;
        .renew-case-name {
          font-weight: 400;
          font-size: 32px;
          color: #333333;
          margin-top: 50px;
        }
        .renew-case-desc {
          margin-top: 42px;
          font-weight: 400;
          font-size: 22px;
          color: #B2B2B2;
        }
      }
      .infoBtn {
        width: 170px;
        height: 46px;
        border-radius: 23px;
        border: 2px solid #4E8B46;
        position: absolute;
        bottom: 62px; 
        left: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 400;
        font-size: 24px;
        color: #4E8B46;
        cursor: pointer;
      }
    }
  }
  .finished {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #999;
    margin-top: 30px;
  } 
}
</style>